module.exports = __webpack_public_path__ + "img/google-play-available.8ee634f5.png";